import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'

import type Collection from '@models/Collection'

const AddedToCollectionDialog: React.FC = () => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)
  return (
    <Dialog name="added_to_collection" title={t('action.addedToCollection')}>
      <DialogBody />
      <div className="flex flex-row w-full justify-end mt-4">
        <Button variant="primary" onClick={() => closeDialog('added_to_collection')}>
          {t('action.ok')}
        </Button>
      </div>
    </Dialog>
  )
}

export default AddedToCollectionDialog

const DialogBody: React.FC = () => {
  const collection = useDialogStore<Collection>((s) => s.state)
  if (!collection) return null
  return (
    <>
      <div>
        <Trans i18nKey="messages.scoreAddedToCollection">
          This score has been added to
          <a
            href={collection.url}
            target="_blank"
            rel="noopener noreferrer"
            className="orange-link"
            title={collection.name}>
            {{ name: collection.name }}
          </a>
        </Trans>
      </div>
      <p className="mt-3">
        <Trans i18nKey="messages.viewCollections">
          You can view your collections in <br />
          My Scores &gt; Collections
        </Trans>
      </p>
    </>
  )
}
